import React from "react";
import { StarFilled } from "@ant-design/icons";

const RatingRow = ({ rating, reviewCount, tag, tagClass }) => (
  <div className="qp-card-rating-row">
    <StarFilled className="qp-star-icon" />
    <span className="qp-rating-value">{rating}</span>
    <span className="qp-rating-count">({reviewCount})</span>
    <span className="qp-rating-divider">|</span>
    <span className={tagClass}>{tag}</span>
  </div>
);

export default RatingRow;

